<template>
  <div class="row">
    <div class="col-md-6 mb-3">
      <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
        <div class="card-body p-15 p-sm-20 p-md-25">
          <h6 class="mb-3">Villes sans zone</h6>
          <input
            v-model="searchTerm1"
            placeholder="Chercher une ville"
            type="text"
            class="form-control d-inline-block mb-3"
          />
          <vue-good-table :columns="columns" :rows="rows1">
            <template #emptystate>
              <center>Aucune entrées correspondants trouvés</center>
            </template>
            <template #table-row="props">
              <span v-if="props.column.field === 'action'">
                <template v-if="auth.can('SETTINGS')">
                  <button
                    class="btn btn-success btn-sm"
                    @click="AddCity(props.row.id)"
                    title="Ajouter Ville"
                  >
                    <i class="flaticon-plus"></i>
                  </button>
                </template>
              </span>
              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>
          </vue-good-table>
          <TablePager
            :pagination="pager1"
            v-model:per-page="perPage1"
            @paginate="getCities1"
          />
        </div>
      </div>
    </div>

    <div class="col-md-6 mb-3">
      <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
        <div class="card-body p-15 p-sm-20 p-md-25">
          <h6 class="mb-3">Villes de la zone</h6>
          <input
            v-model="searchTerm2"
            placeholder="Chercher une ville"
            type="text"
            class="form-control d-inline-block mb-3"
          />
          <vue-good-table :columns="columns" :rows="rows2">
            <template #emptystate>
              <center>Aucune entrées correspondants trouvés</center>
            </template>
            <template #table-row="props">
              <span v-if="props.column.field === 'action'">
                <template v-if="auth.can('SETTINGS')">
                  <button
                    class="btn btn-danger btn-sm"
                    @click="RemoveCity(props.row.id)"
                    title="Supprimer Ville"
                  >
                    <i class="flaticon-delete"></i>
                  </button>
                </template>
              </span>
              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>
          </vue-good-table>
          <TablePager
            :pagination="pager2"
            v-model:per-page="perPage2"
            @paginate="getCities2"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from "vue";
import { useAppToast } from "@/composables/useAppToast";
import { useServerTable } from "@/composables/useServerTable";
import { useAuthStore } from "@/stores/auth";
import { useRoute } from "vue-router";
import api from "@/utils/axios";

export default defineComponent({
  props: {
    id: {
      type: String,
      required: true,
    },
  },

  setup() {
    const route = useRoute();
    const { showToast } = useAppToast();
    const auth = useAuthStore();

    const columns = [
      { label: "Ville", field: "name", sortable: false },
      { label: "Actions", field: "action", sortable: false },
    ];

    // Both lists are paginated and searched by the API (one page of cities at a time)
    const {
      rows: rows1,
      pager: pager1,
      searchTerm: searchTerm1,
      perPage: perPage1,
      load: getCities1,
    } = useServerTable({
      url: "/api/auth/citiesNoZone",
      pick: (data) => data.data,
    });
    const {
      rows: rows2,
      pager: pager2,
      searchTerm: searchTerm2,
      perPage: perPage2,
      load: getCities2,
    } = useServerTable({
      url: () => `/api/auth/zone_cities/${route.params.id}`,
      pick: (data) => data.data,
    });

    // a city moves from one list to the other: reload both from page 1
    const reload = () =>
      Promise.all([getCities1(1), getCities2(1)]).catch(
        () => showToast("Erreur lors de la récupération des villes", "error")
      );

    function handle(res: { data: { message: string } }) {
      if (res.data.message === "success") {
        reload();
        showToast("Vos données sont bien enregistrés", "success");
      } else if (res.data.message === "no city") {
        showToast("Erreur ville n'existe pas", "error");
      } else if (res.data.message === "no zone") {
        showToast("Erreur zone n'existe pas", "error");
      }
    }

    function change(endpoint: string, id: string) {
      const data = new FormData();
      data.append("city_id", id);
      data.append("zone_id", String(route.params.id));
      api
        .post(endpoint, data)
        .then(handle)
        .catch(() => {
          showToast("Something went wrong! Please try again", "error");
        });
    }
    const RemoveCity = (id: string) => change("/api/auth/remove_city_zone", id);
    const AddCity = (id: string) => change("/api/auth/add_city_zone", id);

    onMounted(reload);

    return {
      auth,
      columns,
      rows1,
      rows2,
      pager1,
      pager2,
      searchTerm1,
      searchTerm2,
      perPage1,
      perPage2,
      getCities1,
      getCities2,
      RemoveCity,
      AddCity,
    };
  },
});
</script>
